import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['tierNumber', 'discountType', 'discountValue', 'discountedPrice', 'originalPrice']

  connect() {
    this.tierNumberTarget.innerHTML = this.tierNumberingControllers.length
    this.calculateAndDisplayDiscount()
  }

  updateCounting() {
    setTimeout(() => {
      this.tierNumberingControllers.forEach((tier, index) => {
        tier.tierNumberTarget.innerHTML = index + 1
      })
    }, 100)
  }

  calculateAndDisplayDiscount() {
    let ticketPrice = parseInt(this.ticketFormController.priceFieldTarget.value)
    if (ticketPrice) {
      this.originalPriceTarget.innerHTML = this.formatCurrency(ticketPrice)
      let discountValue = parseInt(this.discountValueTarget.value)
      if (!isNaN(discountValue)) {
        if (this.discountTypeTarget.value == 'dollar') {
          this.discountedPriceTarget.innerHTML = this.formatCurrency(ticketPrice - discountValue)
        } else {
          this.discountedPriceTarget.innerHTML = this.formatCurrency(ticketPrice - ((ticketPrice * discountValue) / 100))
        }
      }
    }
  }

  get ticketFormController() {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === 'ticket-form';
    });
  }

  get tierNumberingControllers() {
    return this.application.controllers.filter(controller => {
      return controller.context.identifier === 'tier-numbering';
    });
  }

  formatCurrency(amount) {
    return `$${parseFloat(amount).toFixed(2)}`
  }
}
